export default "__VITE_ASSET__BM9IUac1__"